<script>
  import { step } from "../stores.js";
  import BackArrow from "../icons/BackArrow.svelte";

  export let disabled = false;
  export let text = "Next Step";
</script>

<button
  {disabled}
  class={`${disabled ? 'bg-gray-200 cursor-not-allowed' : 'bg-brand-orange'} text-white text-sm rounded-lg p-4 inline-flex items-center leading-none`}
  on:click
>
  <BackArrow />
  <span class="pl-2">{text}</span>
</button>
